import { RouteComponentProps } from "react-router";

/*************/
/*  GENERAL  */
/*************/

export interface PuntoServicio {
  codigo: string;
  nombre: string;
  ps_id?: string;
}
export interface InputValidez {
  valido: boolean;
  info: string;
}
export interface InputEstado<T> extends InputValidez {
  valor?: T;
}
export type InputCorte = InputEstado<Corte>

export interface Corte {
  horaEntrada?: Date;
  horaSalida?: Date;
}
export interface CorteProceso {
  horaEntrada: Date;
  horaSalida: Date;
}


/*************/
/*   PAGES   */
/*************/

export type PageProps = RouteComponentProps<{}>
export interface HistorialConFiltroProps {
  user: string;
  cargo: string | undefined;
  cerrarSesion: () => void;
}
export interface HistorialTrabajoFiltrosProps extends RouteComponentProps<{}> {
  filtros: FiltrosHistorial;
  handleFiltrosChange: (filtros: FiltrosHistorial) => void;
}

/*************/
/*   LOGIN   */
/*************/

export interface LoginProps {
  agregarUsuario: (sesion: Sesion) => void;
}
export interface EstadoCedula {
  valor: string;
  valido: boolean; // siempre opuesto a error
  error: boolean; // solo sirve al principio
  ayuda: string;
  ocultarAyuda: boolean;
}
export interface EstadoContraseña {
  valor: string;
  estado: string;
  valido: boolean;
  error: boolean;
  ayuda: string;
}
export type EstadoLogin =
  | "ESPERANDO_CEDULA"
  | "ESPERANDO_CONTRASEÑA"
  | "ESPERANDO_API";

/*****************/
/*   HISTORIAL   */
/*****************/
export type TipoRegistroHistorico = "SIN-A" | "AN" | "OS" | "F" | "Hora Procesada" | "" ;
export type TipoRegistroHistoricoHora = "NORMA" | "HNOC" | "FERIA" | "DOM" | "DONOC";
export interface Fecha {
  fecha: Date;
  tiempoTrabajado: number;
}
export interface FechaDeGrupo {
  fecha: Date;
  tiempoTrabajado: number;
}
export interface FiltrosHistorial {
  puntoDeServicio?: PuntoServicio;
  fechaInicio?: Date;
  fechaFin?: Date;
  soloHorasProcesadas?: boolean;
  soloHorasSinProcesar?: boolean;
}
export interface RegistroHistorialAPI {
  cod_hora: string;
  id: string;
  ps_codigo: string;
  ps_nombre: string;
  op_nombre: string;
  hora_entrada: string;
  hora_salida: string;
  total: string;
  fecha: Date;
  tipo: TipoRegistroHistorico;
}
export interface RegistroHistórico {
  id: string;
  codigoPuntoServicio: string;
  nombrePuntoServicio: string;
  horaEntrada: number;
  horaSalida: number;
  tiempoTrabajado: number;
  fecha: Date;
  tipo: TipoRegistroHistorico;
  cod_hora: string;
}


export interface HistorialTrabajoProps extends RouteComponentProps<{}> {
  cargo: string | undefined;
  filtros: FiltrosHistorial;
}
export interface HistrorialProps extends RouteComponentProps<{}> {
  cargo: string | undefined;
  registros: RegistroHistórico[];
  fechasDeGrupos: FechaDeGrupo[];
}
export interface registroHistorialProps extends RouteComponentProps<{}> {
  id: string;
  cargo: string | undefined;
  codigoPuntoServicio: string;
  nombrePuntoServicio: string;
  horaEntrada: number;
  horaSalida: number;
  tiempoTrabajado: number;
  tipo: TipoRegistroHistorico;
  cod_hora: string;
}

/**************************/
/*   CABECERA HISTORIAL   */
/**************************/

export interface CabeceraFechaProps {
  fecha: Date;
  tiempoTrabajado: number;
}

/****************/
/*   RECLAMOS   */
/****************/

// modelo de reclamos en el sistema
export interface ReclamoProceso {
  nombrePuntoServicio?: string;
  codigoPuntoServicio?: string;
  nombreOperario?: string;
  fechaInicio?: Date;
  cortes: CorteProceso[];
  reclamo: string;
  accion: string;
  comentario?: string;

}
// modelo de reclamos sin hora procesada cuando son creados por operarios
export interface ReclamoCreacionSinProcesadaAPI {
  reclamo: string;
  comentario?: string;
  horas: {
    h_entrada_1: string;
    h_salida_1: string;
  };
  origen: "APP";
  ps_nombre: string;
  ps_codigo: string;
  fecha: string;
}
// modelo de reclamos con hora procesada cuando son creados por operarios
export interface ReclamoCreacionConProcesadaAPI {
  horas: {
    h_entrada_1: string;
    h_salida_1: string;
  };
  reclamo: string;
  comentario?: string;
  origen: "APP";
}
// modelo de reclamos cuando son procesadas por fiscales
export interface ReclamoProcesoAPI {
  he_aprobado: string;
  hs_aprobado: string;
  he_aprobado_1: string;
  hs_aprobado_1: string;
  he_aprobado_2?: string;
  hs_aprobado_2?: string;
  he_aprobado_3?: string;
  hs_aprobado_3?: string;
  observacion?: string;
  aceptar: string;
}
// modelo de reclamos retornados
export interface RegistroReclamoAPI {
  estado: string;
  fecha: string;
  fiscal_comentario: string;
  he_1: string;
  he_2: string;
  he_3: string;
  he_4: string;
  hs_1: string;
  hs_2: string;
  hs_3: string;
  hs_4: string;
  id: string;
  id_horas: string;
  ps_nombre: string;
  ps_codigo: string;
  op_nombre: string;
  reclamo: string;

}
export interface RegistroReclamo extends Fecha {
  id: string;
  codigoPuntoServicio: string;
  nombrePuntoServicio: string;
  nombreOperario: string;
  estadoReclamo: string;
  cortes: CorteProceso[];
  motivo?: string;
  estado: string;
}

export interface FiltrosReclamos {
  puntoDeServicio?: PuntoServicio;
  fechaInicio?: Date;
  fechaFin?: Date;
}


export interface Reclamo {
  puntoServicio: PuntoServicio;
  nombreOperario: string;
  fecha: Date;
  cortesAprobados: CorteProceso[];
  reclamo: string;
}

export interface ReclamosConFiltroProps {
  user: string;
  cargo: string | undefined;
  cerrarSesion: () => void;
}
export interface ReclamosDeTrabajoProps extends RouteComponentProps<{}> {
  cargo: string | undefined;
  filtros: FiltrosReclamos;
}
export interface ReclamosProps extends RouteComponentProps<{}> {
  cargo: string | undefined;
  registros: RegistroReclamo[];
  fechasDeGrupos: FechaDeGrupo[];
}
export interface ReclamoProps extends RouteComponentProps<{}> {
  cargo: string | undefined;
}
export interface ReclamosFiltrosProps extends RouteComponentProps<{}> {
  filtros: FiltrosReclamos;
  handleFiltrosChange: (filtros: FiltrosReclamos) => void;
}
export interface ReclamosProcesosProps {
  cargo: string | undefined;
  cerrarSesion: () => void;
}
export interface RegistroReclamoProps extends RouteComponentProps<{}> {
  id: string;
  cargo: string | undefined;
  codigoPuntoServicio: string;
  nombrePuntoServicio: string;
  nombreOperario: string;
  estadoReclamo: string;
  cortes: CorteProceso[];
  tiempoTrabajado: number;
  motivo?: string;
}
export type TipoReclamo = "procesada" | "no-procesada";

/***************/
/* MARCACIONES */
/***************/

export const EARTH_RADIUS = 6371;
export const RELACION_KM_METROS = 1000;

export interface Posicion {
  latitud: number;
  longitud: number;
}

export interface Marcacion {
  ps_codigo: string;
  ps_nombre: string;
  ps_latitud: number;
  ps_longitud: number;
  distancia: number;
}

export interface MarcacionProps extends RouteComponentProps<{}> {
  marcacion: Marcacion;
}
export interface ListaMarcacionesProps extends RouteComponentProps<{}> {
  marcaciones: Marcacion[];
}

/****************/
/*   SALARIOS   */
/****************/

export interface Salario {
  mes: string;
  bruto: number;
  neto: number;
  detalles: DetalleSalario[];
  horas?: DetalleSalario[];
}

export interface DetalleSalario {
  descripcion: string;
  valor: number;
}

/*************/
/*    U I    */
/*************/

export interface Operario {
  cargo: string;
  usuario: string;
}

export interface AutocompletePropsOp {
  className?: string;
  label: string;
  value: Operario | null;
  setValue: (usuario: Operario | null) => void;
  error?: boolean;
}

export interface Opcion {
  id: string;
  nombre: string;
}
export interface AutocompleteProps {
  className?: string;
  label: string;
  value: Opcion | null;
  setValue: (opcion: Opcion | null) => void;
  error?: boolean;
}

export interface BotonProps {
  className?: string;
  label?: string;
  icon?: string;
  handleClick: () => void;
}

export interface TimePickerProps {
  className?: string;
  placeholder: string;
  setValue: (date?: Date) => void;
  value?: Date;
}

export interface CabeceraFechaProps {
  fecha: Date;
  tiempoTrabajado: number;
}

export interface CheckboxProps {
  label: string;
  checked?: boolean;
  setChecked: (checked: boolean) => void;
  className: string;
}

export interface DatePickerProps {
  className?: string;
  placeholder: string;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  setValue: (date?: Date) => void;
  error?: boolean;
}

export interface IconButton {
  icono?: string;
  src?: string;
  url?: string;
  action?: () => void;
}

export interface HeaderProps {
  titulo: string;
  children?: React.ReactNode;
  text?: string | boolean;
  botonIzq?: IconButton;
  botonesDerecha?: IconButton[];
  textAlign?: "left" | "center" | "right";
  marginBottom?: string;
  marginTop?: string;
  width?: string;
  
}

export interface HelperTextProps {
  className?: string;
  activo: boolean;
  texto: string;
  tipo: "error" | "info";
}

export interface FBAProps {
  icon: string;
  handleClick: () => void;
}

// parametro antes de RadioProps para un input radio
// desde un RadioGroup
export interface Razon {
  valor: string;
  detalles: boolean;
}
export interface RadioProps {
  label: string;
  value: string;
  className?: string;
  requestDetail?: boolean;
  implicitSelect?: (event: any, value: string) => void;
}

export interface SpinnerProps {
  activo: boolean;
  texto?: string;
}

/*************/
/*    MENU   */
/*************/

export interface MenuProps extends RouteComponentProps<{}> {
  user: string;
  cargo: string | undefined;
  cerrarSesion: () => void;
  contentId: string;
}
export interface AppPage {
  url?: string;
  icon?: string;
  src?: string;
  title: string;
  onClick?: () => void;
  cargos?: string[]; // cargos que puedan ver la pagina
}

/***************/
/* SIMPLE LIST */
/***************/

export interface SimpleListItem {
  id: string;
  title: string;
  subtitle: string;
  options?: InteractiveOption[];
}

export interface SimpleListItemProps {
  items: SimpleListItem[];
}

/**************/
/*  DROPDOWN  */
/**************/

export interface InteractiveOption {
  text: string;
  action: () => void;
}

export interface DropdownProps {
  options: InteractiveOption[];
}

/**************/
/*   DIALOG   */
/**************/

export interface DialogProps {
  open: boolean;
  title: string;
  message: JSX.Element;
  setOpen: (open: boolean) => void;
}

/***************/
/* ESPECIFICOS */
/***************/

export interface Sesion {
  token: string;
}

export type CategoriaMensajeInicio =
  | 'valores_corporativos'
  | 'calidad_servicio'
  | 'etica_conducta'
  | 'politica'
  | 'rse';

export interface Frase {
  mensaje: string;
  categoria: CategoriaMensajeInicio;
}

/***************/
/* ASIGNACIONES */
/***************/


export interface AsignacionProps extends RouteComponentProps<{}> {
  cargo: string | undefined;
}

export interface AsignacionConFiltroProps {
  user: string;
  cargo: string | undefined;
  cerrarSesion: () => void;

}

export interface HeaderAsignacionProps {
  titulo: string;
  botonIzq?: IconButton;
  botonesDerecha?: [IconButton];
  PuntoServicio?: [PuntoServicio];
}



//////////////////////////////////////////////////
// PARAMETROS PARA LISTAR PUNTOS DE SERVICIOS ///
//Y CANTIDAD DE OPERARIOS ASIGNADOS          ///
///////////////////////////////////////////////
export interface Asignacion {
  datos: Dato[];
}

export interface Dato {
  cantidad:  number;
  ps_codigo: string;
  ps_id:     number;
  ps_nombre: string;
}

// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
export class Convert {
  public static toAsignacion(json: string): Asignacion {
      return cast(JSON.parse(json), r("Asignacion"));
  }

  public static asignacionToJson(value: Asignacion): string {
      return JSON.stringify(uncast(value, r("Asignacion")), null, 2);
  }
}

function invalidValue(typ: any, val: any, key: any, parent: any = ''): never {
  const prettyTyp = prettyTypeName(typ);
  const parentText = parent ? ` on ${parent}` : '';
  const keyText = key ? ` for key "${key}"` : '';
  throw Error(`Invalid value${keyText}${parentText}. Expected ${prettyTyp} but got ${JSON.stringify(val)}`);
}

function prettyTypeName(typ: any): string {
  if (Array.isArray(typ)) {
      if (typ.length === 2 && typ[0] === undefined) {
          return `an optional ${prettyTypeName(typ[1])}`;
      } else {
          return `one of [${typ.map(a => { return prettyTypeName(a); }).join(", ")}]`;
      }
  } else if (typeof typ === "object" && typ.literal !== undefined) {
      return typ.literal;
  } else {
      return typeof typ;
  }
}

function jsonToJSProps(typ: any): any {
  if (typ.jsonToJS === undefined) {
      const map: any = {};
      typ.props.forEach((p: any) => map[p.json] = { key: p.js, typ: p.typ });
      typ.jsonToJS = map;
  }
  return typ.jsonToJS;
}

function jsToJSONProps(typ: any): any {
  if (typ.jsToJSON === undefined) {
      const map: any = {};
      typ.props.forEach((p: any) => map[p.js] = { key: p.json, typ: p.typ });
      typ.jsToJSON = map;
  }
  return typ.jsToJSON;
}

function transform(val: any, typ: any, getProps: any, key: any = '', parent: any = ''): any {
  function transformPrimitive(typ: string, val: any): any {
      if (typeof typ === typeof val) return val;
      return invalidValue(typ, val, key, parent);
  }

  function transformUnion(typs: any[], val: any): any {
      // val must validate against one typ in typs
      const l = typs.length;
      for (let i = 0; i < l; i++) {
          const typ = typs[i];
          try {
              return transform(val, typ, getProps);
          } catch (_) {}
      }
      return invalidValue(typs, val, key, parent);
  }

  function transformEnum(cases: string[], val: any): any {
      if (cases.indexOf(val) !== -1) return val;
      return invalidValue(cases.map(a => { return l(a); }), val, key, parent);
  }

  function transformArray(typ: any, val: any): any {
      // val must be an array with no invalid elements
      if (!Array.isArray(val)) return invalidValue(l("array"), val, key, parent);
      return val.map(el => transform(el, typ, getProps));
  }

  function transformDate(val: any): any {
      if (val === null) {
          return null;
      }
      const d = new Date(val);
      if (isNaN(d.valueOf())) {
          return invalidValue(l("Date"), val, key, parent);
      }
      return d;
  }

  function transformObject(props: { [k: string]: any }, additional: any, val: any): any {
      if (val === null || typeof val !== "object" || Array.isArray(val)) {
          return invalidValue(l(ref || "object"), val, key, parent);
      }
      const result: any = {};
      Object.getOwnPropertyNames(props).forEach(key => {
          const prop = props[key];
          const v = Object.prototype.hasOwnProperty.call(val, key) ? val[key] : undefined;
          result[prop.key] = transform(v, prop.typ, getProps, key, ref);
      });
      Object.getOwnPropertyNames(val).forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(props, key)) {
              result[key] = transform(val[key], additional, getProps, key, ref);
          }
      });
      return result;
  }

  if (typ === "any") return val;
  if (typ === null) {
      if (val === null) return val;
      return invalidValue(typ, val, key, parent);
  }
  if (typ === false) return invalidValue(typ, val, key, parent);
  let ref: any = undefined;
  while (typeof typ === "object" && typ.ref !== undefined) {
      ref = typ.ref;
      typ = typeMap[typ.ref];
  }
  if (Array.isArray(typ)) return transformEnum(typ, val);
  if (typeof typ === "object") {
      return typ.hasOwnProperty("unionMembers") ? transformUnion(typ.unionMembers, val)
          : typ.hasOwnProperty("arrayItems")    ? transformArray(typ.arrayItems, val)
          : typ.hasOwnProperty("props")         ? transformObject(getProps(typ), typ.additional, val)
          : invalidValue(typ, val, key, parent);
  }
  // Numbers can be parsed by Date but shouldn't be.
  if (typ === Date && typeof val !== "number") return transformDate(val);
  return transformPrimitive(typ, val);
}

function cast<T>(val: any, typ: any): T {
  return transform(val, typ, jsonToJSProps);
}

function uncast<T>(val: T, typ: any): any {
  return transform(val, typ, jsToJSONProps);
}

function l(typ: any) {
  return { literal: typ };
}

function a(typ: any) {
  return { arrayItems: typ };
}

// function u(...typs: any[]) {
//   return { unionMembers: typs };
// }

function o(props: any[], additional: any) {
  return { props, additional };
}

// function m(additional: any) {
//   return { props: [], additional };
// }

function r(name: string) {
  return { ref: name };
}

const typeMap: any = {
  "Asignacion": o([
      { json: "datos", js: "datos", typ: a(r("Dato")) },
  ], false),
  "Dato": o([
      { json: "cantidad", js: "cantidad", typ: 0 },
      { json: "ps_codigo", js: "ps_codigo", typ: "" },
      { json: "ps_id", js: "ps_id", typ: 0 },
      { json: "ps_nombre", js: "ps_nombre", typ: "" },
  ], false),
};



///////////////////////////////////////////////
// PARAMETROS PARA MOSTRAR PUNTOS DETALLES ///
//DEL PUNTO DE SERVICIO                   ///
////////////////////////////////////////////

export interface CupoAsignado {
  DOMIN: string;
  DONOC: string;
  HNOC:  string;
  NORMA: string;
  total: string;
}

export interface cupoHora {
  DOMIN: string; 
  DONOC: string;
  FENOC: string;
  FERIA: string;
  HNOC:  string;
  HNOCM: string;
  NORMA: string;
  total: string;
}

export interface cupoRestante {
  DOMIN: string; 
  DONOC: string;
  FENOC: string;
  FERIA: string;
  HNOC:  string;
  HNOCM: string;
  NORMA: string;
  total: string;
}





export interface detalleOperarioAsignado {
  datos: Datos[];
}

export interface Datos {
  id:             number;
  legajo:         string;
  operario:       string;
  total_asignado: string;
}

export interface DetalleCortesCupo {
  datos: Dato[];
}

export interface DetalleCortesOperarios {
  dom_ent:      null | string;
  dom_sal:      null | string;
  fecha_inicio: Date;
  id:           number;
  jue_ent:      null | string;
  jue_sal:      null | string;
  lun_ent:      null | string;
  lun_sal:      null | string;
  mar_ent:      null;
  mar_sal:      null;
  mie_ent:      null | string;
  mie_sal:      null | string;
  sab_ent:      string;
  sab_sal:      string;
  total_horas:  string;
  vie_ent:      null | string;
  vie_sal:      null | string;
  viatico_gourmet?:       boolean | number;
  viatico_operario?:      boolean | number;
  viatico_gourmet_monto?: null | string;
  viatico_operario_monto?: null | string;
}

export interface DisponibilidadBeneficios {
  gourmet_total:      string;
  gourmet_usado:      string;
  gourmet_disponible: string;
  viatico_total:      string;
  viatico_usado:      string;
  viatico_disponible: string;
}



export interface ListaOperario {
  datos: Dato_Operario[];
}

export interface Dato_Operario {
  cargo:  Cargo;
  legajo: string;
  nombre: string;
}

export enum Cargo {
  Operario = "OPERARIO",
  OperarioAreasVerdesYExternas = "OPERARIO AREAS VERDES Y EXTERNAS",
  OperarioContactCenter = "OPERARIO CONTACT CENTER",
  OperarioEspecialista = "OPERARIO ESPECIALISTA",
  OperarioInterior = "OPERARIO INTERIOR",
  OperarioInvernadero = "OPERARIO INVERNADERO",
  OperarioManoDeObra = "OPERARIO MANO DE OBRA",
  OperarioMontacargas = "OPERARIO MONTACARGAS",
  OperarioOcasionales = "OPERARIO OCASIONALES",
  OperarioTiempoParcial = "OPERARIO TIEMPO PARCIAL",
  OperarioVidriero = "OPERARIO VIDRIERO",
}

export interface GuardarAsignacion {
  datos: DatoGuardarAsignacion[];
}

export interface DatoGuardarAsignacion {
  ps_id:       number;
  operario:    string;
  fecha_ini:   string;
  fecha_fin:   null;
  lun_ent:     string;
  lun_sal:     string;
  mar_ent:     null;
  mar_sal:     null;
  mie_ent:     null;
  mie_sal:     string;
  jue_ent:     string;
  jue_sal:     null;
  vie_ent:     null;
  vie_sal:     null;
  sab_ent:     string;
  sab_sal:     string;
  dom_ent:     null;
  dom_sal:     null;
  total_horas: null;
}


export interface ListarOperarioRemplazo {
  datos: DatoRemplazo[];
}

export interface DatoRemplazo {
  NombrePServicio: string;
  asig_cab_id:     number;
  dom_ent:         null;
  dom_sal:         null;
  estado:          string;
  fecha_inicio:    Date;
  id:              number;
  jue_ent:         string;
  jue_sal:         string;
  lun_ent:         string;
  lun_sal:         string;
  mar_ent:         string;
  mar_sal:         string;
  mie_ent:         string;
  mie_sal:         string;
  operario_ci:     string;
  operario_id:     number;
  ps_id:           number;
  sab_ent:         null | string;
  sab_sal:         null | string;
  total_horas:     number;
  vie_ent:         string;
  vie_sal:         string;
}

export interface totalHorasCupo {
  DOMIN:null | string;
  DONOC:null | string;
  FENOC:null | string;
  FERIA:null | string;
  HNOC: null | string;
  HNOCM:null | string;
  NORMA:null | string;
  TOTAL:null | string;
}


export interface ListarOperarioRemplazo {
  operariosDisponibles: OperariosDisponible[];
}

export interface OperariosDisponible {
  fechaInicioRemplazante: string;
  fechaFinRemplazante:    string;
  dias:                   string[];
  remplazante:            string;
  horaEntradaRemplazante: string;
  horaSalidaRemplazante:  string;
}

export interface ListarOperarioRemplazo {
  cargaRemplazo: CargaRemplazo[];
}

export interface CargaRemplazo {
  fechaInicioRemplazante: Date;
  fechaFinRemplazante:    Date;
  dias:                   string[];
  puntoServicio:          string;
  remplazo:               string;
  remplazante:            string;
  horaEntradaRemplazante: string;
  horaSalidaRemplazante:  string;
}


export interface DiasDisponibles {
  dias: Dias[];
}
export interface Dias {
 dia: string | null;
 nombre: string;
}

export interface ListarOperarioRemplazo {
  vistaRemplazoDatos: VistaRemplazoDato[];
}

export interface VistaRemplazoDato {
  asignaciones:      null;
  dom_ent:           null;
  dom_sal:           null;
  estado:            boolean;
  fecha_fin:         Date;
  fecha_inicio:      Date;
  id:                number;
  jue_ent:           null | string;
  jue_sal:           null | string;
  lun_ent:           string;
  lun_sal:           string;
  mar_ent:           string;
  mar_sal:           string;
  mie_ent:           string;
  mie_sal:           string;
  nombre_ps:         string;
  nombre_remplazado: string;
  nombre_remplazo:   string;
  ps_id:             number;
  sab_ent:           null;
  sab_sal:           null;
  vie_ent:           null | string;
  vie_sal:           null | string;
}

export interface CupoGestion {
  cupos: Cupos;
  datos: DatoCupoGestion[];
}

export interface Cupos {
  DOMIN?: string;
  DONOC?: string;
  FENOC?: string;
  FERIA?: string;
  HNOC?:  string;
  HNOCM?: string;
  NORMA?: string;
}

export interface DatoCupoGestion {
  entrada?:         string;
  entrada_id?:      number;
  estado?:          string;
  fecha?:           Date;
  idMarcacion?:     number;
  nombre?:          string;
  nombrePServicio?: string;
  nroLegajo?:       string;
  salida?:          null;
  salida_id?:       null;
  tipoHora?:        null;
  tipoMarcacion?:   string;
  total?:           null;
}



/*************************/
/* REEMBOLSO DE PASAJES  */
/*************************/

export interface ReembolsoTraslado {
  id: number;
  fecha: string;
  periodo: string;
  orden: number;
  ps_origen: string;
  ps_destino: string;
  hora_salida?: string;
  hora_llegada?: string;
  cant_buses?: number;
  costo_pasaje?: number;
  monto?: number;
  distancia_metros?: number;
  duracion_segundos?: number;
  estado: "GENERADO" | "APROBADO" | "RECHAZADO" | "OBSERVADO";
  origen: "CALCULO" | "RECLAMO";
  motivo_rechazo?: string;
  observado?: boolean;
}

export interface ReembolsoMes {
  mes: string;
  total_aprobado: number;
  total_pendiente: number;
  cantidad: number;
  traslados: ReembolsoTraslado[];
}

export interface ReembolsoReclamo {
  id: number;
  fecha: string;
  ps_origen: string;
  ps_destino: string;
  ps_texto?: string;
  comentario?: string;
  estado: "PENDIENTE" | "APROBADO" | "RECHAZADO";
  respuesta_gestion?: string;
  fecha_alta?: string;
  traslado_id?: number;
}

export interface NuevoReclamoPasaje {
  fecha: string;
  ps_origen_id?: number;
  ps_destino_id?: number;
  ps_texto?: string;
  comentario?: string;
}

export interface ReembolsoPS {
  id: number;
  nombre: string;
}
